import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
